import { render, staticRenderFns } from "./IconSvgMore.vue?vue&type=template&id=7dfa5e48&scoped=true&"
import script from "./IconSvgMore.vue?vue&type=script&lang=js&"
export * from "./IconSvgMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfa5e48",
  null
  
)

export default component.exports